import { useEffect, useState } from "react";
import axios from "axios";

export default function Register() {

  const [data, setData]=useState({
    id:"",
    name:"",
    email:"",
    phone:"",
    address:""
  })



const handleInputChange=(event)=>{
  const {name, value}= event.target;
  setData((prevProps)=>({
    ...prevProps,
    [name]:value
  }))

}


const handleSubmit=(events)=>
{

 axios.post("http://localhost:5000/addstudent",data)
 .then((response)=>{

     if(response.status==200)
     {
      alert("datainsert")
     }

 })
}

  


  return (
    <>
    <div className='col-md-10 content'>
      <h1>Register Here</h1>
      <span>Enter Adhaar Id :</span><input name="id" value={data.id} onChange={handleInputChange}  placeholder="enter id" /><br/><br/>
      <span>Enter Name : </span><input name="name" value={data.name} onChange={handleInputChange}  /><br/><br/>
      <span>Enter Email : </span><input name="email" value={data.email} onChange={handleInputChange} /><br/><br/>
      <span>Enter Phone : </span><input name="phone" value={data.phone} onChange={handleInputChange} /><br/><br/>
      <span>Enter Address : </span><input name="address" value={data.address} onChange={handleInputChange}  /><br/><br/>

      <button onClick={handleSubmit}  className="btn btn-success" >Submit</button>
    </div>
    </>
  )
}
